import defaultItems from '../../../../../common/defaultItems';
import { getClient } from '../../../../../common/launchDarklyClient';

const AUTHOR_KYLA = 'Kyla Sims, Content Strategist';

const quoteList = [
    {
        author: AUTHOR_KYLA,
        quote: 'When it comes to writing engaging content for your employee newsletter (or any channel really), it’s not what you’re writing about, it’s how you’re writing about it.',
    },
    {
        author: 'Jason Anthoine, Managing Founder of Audacity',
        quote: 'Doing measurement isn’t just to prove, but to improve.',
    },
    {
        author: 'Saskia Jones, Communications Consultant',
        quote: 'It is so important to use words that others understand and not to use them to sound impressive.',
    },
    {
        author: AUTHOR_KYLA,
        quote: 'All the data you collect is valuable, even if it shows that you’re not doing as well as you’d like. Keep it up and try not to take the data too personally.',
    },
    {
        author: AUTHOR_KYLA,
        quote: 'Just because you aren’t seeing huge jumps in the data, it doesn’t mean you aren’t improving. Measuring and testing your approach isn’t a one-time thing. It takes patience and consistency.',
    },
    {
        author: AUTHOR_KYLA,
        quote: 'You’re communicating with real people, with real lives, and real feelings and thoughts. So make sure your emails take THEIR experience, feedback, and perspective into account.',
    },
    {
        author: 'Helen Deverell, Communications Consultant',
        quote: 'There is a desire to always paint things as a bit too perfect or share success stories. Don’t worry about being so perfect and be a bit more honest.',
    },
    {
        author: AUTHOR_KYLA,
        quote: 'Find a way to get excited about what you are communicating and translate that enthusiasm. When you communicate with genuine enthusiasm, that excitement is catching and engaging.',
    },
    {
        author: AUTHOR_KYLA,
        quote: 'Emotionally honest writing is the most effective way to engage people with your story or content.',
    },
    {
        author: AUTHOR_KYLA,
        quote: 'You don’t need a huge vocabulary or to be an expert to clearly communicate an idea. Simple is always better.',
    },
];

const getQuoteFlag = () => {
    const ldClient = getClient();
    if (!ldClient) {
        return false;
    }
    return (
        // Only applies to the new editor, so check that flag as well
        ldClient.variation('ed-427-quote-block-styling', false) &&
        ldClient.variation('pik-1913-text-editor-module', false)
    );
};

export default function () {
    const quoteItem = quoteList[Math.floor(Math.random() * quoteList.length)];
    const { author } = quoteItem;
    const { quote } = quoteItem;
    const isQuoteFixActive = getQuoteFlag();

    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Quote',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                paddingTop: 0,
                                paddingRight: 10,
                                paddingBottom: 0,
                                align: 'left',
                                fontSize: '16px',
                                lineHeight: '34px',
                                textMarkupValue: isQuoteFixActive
                                    ? '<h1 style="text-align: left">“</h1>'
                                    : '<h1>“</h1>',
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                paddingTop: 0,
                                paddingBottom: 0,
                                paddingRight: 32,
                                paddingLeft: 35,
                                align: 'left',
                                fontSize: '14px',
                                lineHeight: '18.2px',
                                textMarkupValue: `<p><span><em>${quote}</em><span></p>`,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                paddingTop: 0,
                                paddingRight: 10,
                                paddingBottom: 0,
                                paddingLeft: 10,
                                align: 'right',
                                fontSize: '16px',
                                lineHeight: '36px',
                                textMarkupValue: isQuoteFixActive
                                    ? '<h1 style="text-align: right">”</h1>'
                                    : '<h1>”</h1>',
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                paddingTop: 10,
                                align: 'right',
                                paddingRight: 10,
                                fontSize: '14px',
                                paddingLeft: 10,
                                lineHeight: '21px',
                                textMarkupValue: `<p><span><strong>~ ${author}</strong></span></p>`,
                                paddingBottom: 10,
                            },
                        },
                    ],
                },
            ],
        },
    };
}
